import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { LoadingToastComponentProps } from '@raptor-fe/core';

interface LoadingToastState {
  loadingItems: LoadingToastComponentProps[];
}

const initialState: LoadingToastState = {
  loadingItems: [],
};

@Injectable({
  providedIn: 'root',
})
export class LoadingToastController extends ComponentStore<LoadingToastState> {
  readonly loadingItems$ = this.select((state) => state.loadingItems);

  readonly addLoadingToast = this.updater((state, item: LoadingToastComponentProps) => {
    const doesNameExist = state.loadingItems.some(
      (existingItem) => existingItem.name === item.name,
    );

    if (!doesNameExist) {
      return {
        ...state,
        loadingItems: [...state.loadingItems, item],
      };
    }

    return state;
  });

  readonly removeLoadingToast = this.updater((state, name: string) => {
    const loadingItems = state.loadingItems.filter((loader) => loader.name !== name);
    return {
      ...state,
      loadingItems: loadingItems,
    };
  });

  constructor() {
    super(initialState);
  }
}
